import React from 'react'
import { observer } from 'mobx-react'
import Skeleton from 'react-loading-skeleton'

import { isMobileDevice } from '@flowwai-frontend/shared/utils/web'

import { REACT_LOADING_DURATION } from '../../Loader/constants'

import {
   TaskManagementHeaderLoadingWrapper,
   AppPrefixAndDisplaNameLoadingWrapper,
   MobileAppProfileLoadingWrapper
} from './styledComponents'

interface TaskManagementHeaderLoaderProps {
   isFromWithProjectsList?: boolean
}

class TaskManagementHeaderLoader extends React.Component<
   TaskManagementHeaderLoaderProps
> {
   renderDesktopHeaderLoader = () => (
      <TaskManagementHeaderLoadingWrapper>
         <AppPrefixAndDisplaNameLoadingWrapper>
            <Skeleton
               duration={REACT_LOADING_DURATION}
               width={40}
               height={40}
               style={{ borderRadius: 6 }}
            />
            <Skeleton
               duration={REACT_LOADING_DURATION}
               width={240}
               height={16}
               style={{ marginLeft: 8 }}
            />
         </AppPrefixAndDisplaNameLoadingWrapper>
      </TaskManagementHeaderLoadingWrapper>
   )

   renderMobileHeaderLoader = () => (
      <TaskManagementHeaderLoadingWrapper>
         <MobileAppProfileLoadingWrapper>
            <Skeleton
               duration={REACT_LOADING_DURATION}
               width={32}
               height={32}
               style={{ borderRadius: 6 }}
            />
            <Skeleton
               duration={REACT_LOADING_DURATION}
               width={80}
               height={18}
               style={{ marginLeft: 8 }}
            />
            <Skeleton
               duration={REACT_LOADING_DURATION}
               width={80}
               height={18}
               style={{ marginLeft: 8 }}
            />
         </MobileAppProfileLoadingWrapper>
      </TaskManagementHeaderLoadingWrapper>
   )

   render() {
      const {
         renderDesktopHeaderLoader: RenderTaskManagementHeaderLoader
      } = this
      if (isMobileDevice) {
         return this.renderMobileHeaderLoader()
      }
      return <RenderTaskManagementHeaderLoader />
   }
}

export default observer(TaskManagementHeaderLoader)
